import Vue from 'vue';
import '@sh/vue-component-ui';
import 'font-awesome/css/font-awesome.css';
import '@sh/vue-component-ui/dist/sh.css';
import App from './App';
import router from './router';

import './assets/styles/style.sass';

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
